<template>
  <div>
    <nav class="bar bar-nav">
      <h1 class="title">注册协议</h1>
    </nav>
    <modal-register-agreement @close="showModal = false" :show.sync="showModal"></modal-register-agreement>
  </div>
</template>


<script>
  import modalRegisterAgreement from '../../../components/ModalRegisterAgreement.vue'

  export default {
    mounted () {
    },
    created () {
    },
    data () {
      return {
        showModal: true
      }
    },
    computed: {
    },
    watch: {
    },
    methods: {
    },
    components: {
      modalRegisterAgreement
    }
  }
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// MyAgreement.vue?4a9b17ab